var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isCatcher)?_c('Catcher'):(_vm.isDice)?_c('Dice'):(_vm.isMines)?_c('Mines'):(_vm.isCrash)?_c('Crash'):(_vm.isFrutto)?_c('Frutto'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }